import { render } from "./DesignPostQuestionPage.vue?vue&type=template&id=38583768&scoped=true&ts=true"
import script from "./DesignPostQuestionPage.vue?vue&type=script&lang=ts"
export * from "./DesignPostQuestionPage.vue?vue&type=script&lang=ts"

import "./DesignPostQuestionPage.vue?vue&type=style&index=0&id=38583768&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38583768"]])

export default __exports__